import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../constants/svgIcon';
import { SvgIcon } from '../../Molecules';
import { ActionSheetContainer } from '../Containers/ActionSheetContainer';

import styles from './JourneyOptionsPopup.module.css';

type JourneyOptionsPopupProps = {
  onRenameJourney: () => void;
  onDeleteJourney: () => void;
  onCancel: () => void;
};

export const JourneyOptionsPopup = ({
  onRenameJourney,
  onDeleteJourney,
  onCancel,
}: JourneyOptionsPopupProps) => {
  const { t } = useTranslation();

  return (
    <ActionSheetContainer onPrimaryButtonClick={onCancel}>
      <div className={styles.menu}>
        <div className={styles.buttonRow} onClick={onRenameJourney}>
          <div className={styles.icon}>
            <SvgIcon
              name={SVGIconType.Rename}
              color="#333"
              width={24}
              height={24}
            />
          </div>
          <p className={styles.text}>{t('Rename')}</p>
        </div>
        <hr className={styles.divider} />
        <div className={styles.buttonRow} onClick={onDeleteJourney}>
          <div className={styles.icon}>
            <SvgIcon
              name={SVGIconType.RubbishBin}
              color="#333"
              width={24}
              height={24}
            />
          </div>
          <p className={styles.text}>{t('Delete Journey')}</p>
        </div>
      </div>
    </ActionSheetContainer>
  );
};
